import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import seo from "../seo.json";

// Sets the page title, description, canonical link and share tags for the
// current route from src/seo.json. The build writes the same tags into each
// page's HTML (scripts/seo-pages.js) for crawlers and link previews that don't
// run JavaScript; this keeps them right as people move between pages.

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function metaFor(pathname) {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : "/";
  return { path, page: seo.pages[path] || seo.pages["/"], known: !!seo.pages[path] };
}

export default function PageMeta() {
  const { pathname } = useLocation();
  useEffect(() => {
    const { path, page, known } = metaFor(pathname);
    const url = `${seo.site}${known ? (path === "/" ? "/" : path) : "/"}`;
    const image = `${seo.site}${page.image || "/og-image.jpg"}`;
    document.title = page.title;
    setMeta("name", "description", page.description);
    setMeta("name", "robots", page.noindex ? "noindex, follow" : "index, follow, max-image-preview:large");
    setCanonical(url);
    setMeta("property", "og:title", page.title);
    setMeta("property", "og:description", page.description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", image);
    setMeta("property", "og:image:alt", page.title);
    setMeta("name", "twitter:title", page.title);
    setMeta("name", "twitter:description", page.description);
    setMeta("name", "twitter:image", image);
  }, [pathname]);
  return null;
}
